import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { AmountFormatted } from '@root/shared/core/format'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type TrackedWalletTableRemainingCellProps = {
  balanceInUsd: BigNumber
  balanceInUsdPercentage: BigNumber
} & ClassNameProps

export const TrackedWalletTableRemainingCell: React.FC<
  TrackedWalletTableRemainingCellProps
> = (props: TrackedWalletTableRemainingCellProps) => {
  return (
    <Root className={props.className}>
      <AmountUsd>
        <AmountFormatted
          amount={props.balanceInUsd}
          currency="$"
          roundingMode="trunc"
        />
      </AmountUsd>
      <AmountPercentage>
        <Numeric value={props.balanceInUsdPercentage} preset="percents" />%
      </AmountPercentage>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-items: start;

  gap: 1px;
  height: 34px;
`

const AmountUsd = styled.div`
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const AmountPercentage = styled.div`
  color: var(--text-9);
  background: var(--background-3);

  border-radius: 3px;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;

  padding: 2px 4px;
`
